import services from 'api/services';
import {
  GET_ALL_CHALLENGES_REQUEST,
  GET_ALL_CHALLENGES_SUCCESS,
  GET_ALL_CHALLENGES_FAILURE,
  SET_FILTERS,
  GET_ME_REQUEST,
  GET_ME_SUCCESS,
  GET_ME_FAILURE,
} from './constants';
import { logError } from 'util/errors';

const { ChallengeService, AuthService, CourseService } = services;
const stripHtml = (html) => html.replace(/(<([^>]+)>)/gi, '');

export const getAllChallenges = (type) => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_CHALLENGES_REQUEST });
    const challenges =
      type === 'courses' ? await CourseService.getAllCourses() : await ChallengeService.getAllItems(type);
    dispatch({
      type: GET_ALL_CHALLENGES_SUCCESS,
      challenges: challenges.map((item) => {
        item.image = item.contestBackground;
        if (type === 'exercises' || type === 'freecode' || type === 'courses')
          item.thumbnail = item.backgroundImage ? item.backgroundImage.thumbnail : undefined;
        item.keywords = item.tags || [];
        item.html = item.landingPageContent;
        item.description =
          type === 'exercises' || type === 'freecode' || type === 'courses'
            ? item.description
            : stripHtml(item.landingPageContent || '');
        delete item.backgroundImage;
        delete item.tags;
        return item;
      }),
    });
  } catch (ex) {
    logError(ex);
    dispatch({ type: GET_ALL_CHALLENGES_FAILURE, error: ex.message });
  }
};

export const setTagFilters = (filters) => async (dispatch) => {
  dispatch({ type: SET_FILTERS, filters });
};

export const getProfile = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ME_REQUEST });
    const {
      user,
      challenges,
      tournaments,
      trophies,
      activities,
      totalNumberOfAchievements,
      completedAchievements,
      latestCompletedAchievement,
      level,
      xpForLevel,
      xpInThisLevel,
    } = await AuthService.getProfile();
    dispatch({
      type: GET_ME_SUCCESS,
      profile: user,
      challenges,
      tournaments,
      trophies,
      activities,
      totalNumberOfAchievements,
      completedAchievements,
      latestCompletedAchievement,
      level,
      xpForLevel,
      xpInThisLevel,
    });
  } catch (ex) {
    logError(ex);
    dispatch({ type: GET_ME_FAILURE, error: ex.message });
  }
};
